export default __webpack_public_path__ + "static/media/EmailToReportingTeam_Icon.d1f3efd6.png";